import { ArrowContainer } from 'react-tiny-popover';
import React, { useContext } from 'react';
import { CustomDatePicker } from '@/features/details/date-pick/custom-picker';
import { DatePickerChip } from '@/features/details/date-pick/chip';
import { QuickRangePicker } from '@/features/details/date-pick/quick-range-select';
import { DatePickerContext } from '@/features/details/date-pick/context';
import { VersionsSelect } from '@/features/details/date-pick/versions-select';
import { ResponsivePopover } from '@/components/responsive-popover';

type Props = {
  open: boolean;
  onClick: () => void;
  whiteBg?: boolean;
};

export function DatePicker({ onClick, open, whiteBg }: Props) {
  const { showQuickSelect, showCustomDatePicker, showVersionsSelect } =
    useContext(DatePickerContext);

  return (
    <ResponsivePopover
      onClickOutside={onClick}
      isOpen={open}
      containerStyle={{ zIndex: `1000` }}
      positions={[`bottom`, `left`, `right`]}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor="white"
          arrowSize={20}
        >
          <div>
            <div style={{ display: showCustomDatePicker ? `block` : `none` }}>
              <CustomDatePicker close={onClick} />
            </div>
            <div style={{ display: showQuickSelect ? `block` : `none` }}>
              <QuickRangePicker close={onClick} />
            </div>
            <div style={{ display: showVersionsSelect ? `block` : `none` }}>
              <VersionsSelect close={onClick} />
            </div>
          </div>
        </ArrowContainer>
      )}
    >
      <DatePickerChip whiteBg={whiteBg} onClick={onClick} />
    </ResponsivePopover>
  );
}
